import { useMemo } from 'react';
import {
  CustomizeAssetLayout,
  type CustomizeAssetTab,
} from './CustomizeAssetLayout';
import { SpeakerNotesTab } from './SpeakerNotesTab';

type CustomizeTourProps = { entityId: string };

export const CustomizeTour = ({ entityId }: CustomizeTourProps) => {
  const tabs = useMemo<CustomizeAssetTab[]>(
    () => [
      {
        id: 'speakerNotes',
        label: 'Notes',
        content: (
          <SpeakerNotesTab
            entityId={entityId}
            entityType="tour"
          />
        ),
      },
    ],
    [entityId]
  );
  return <CustomizeAssetLayout tabs={tabs} />;
};
